import { render, staticRenderFns } from "./InformationHeader.vue?vue&type=template&id=917c7cba"
import script from "./InformationHeader.vue?vue&type=script&lang=js"
export * from "./InformationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports